// extracted by mini-css-extract-plugin
export default {"PlainFeature":"ws_a bih_b"};